import {DrawFrmThing} from "../../../drawfrm/DrawFrmThing";
import {lineBlueHeavy} from "../../../const";
import {FrmShape} from "../../../drawfrm/FrmShape";
import {FrameProfileArgs} from "./ProfileArgs";
import {FrmRefPoint} from "../../../drawfrm/FrmRefPoint";

export class FrameProfileFF extends DrawFrmThing {

    primaryDoorAnchor = new FrmRefPoint();
    // top of the outer face; the frame-profile view aligns a clamshell mullion on this.
    faceAnchor = new FrmRefPoint();

    constructor(args: FrameProfileArgs) {
        super();
        const {detail, jambDepth, jambFace, view, app, left, swingIn, hideFaces, hideFaceDims, flipY} = args;

        const shape = new FrmShape(`frameProfile:FF:${left ? "left" : "right"}`, {
            dimensionMode: view.dimensionMode,
            thing: this,
            app: app,
        });
        shape.strokeColor = lineBlueHeavy;
        shape.horizontalDimensionSide = left ? "left" : "right";
        if (!left) shape.invertX();
        if((!swingIn) !== !!flipY) shape.invertY();

        //  ----|
        //      |
        //      |
        //      ----|
        //          |
        //          |
        //      ----|
        //      |
        //  ----|

        const startPoint = shape.start(0, 0);

        const topFace = shape.lineTo(10, 0);

        // rabbet
        const rabbet = shape.lineTo(0, 20);
        shape.addDimension(rabbet.pointA, rabbet.pointB, detail.rabbetDepth);
        this.primaryDoorAnchor.setLocalPoint(rabbet.pointB);

        const indent = shape.lineTo(20, 0);
        shape.lineTo(0, 40);

        const indentRef = shape.lineTo(-20, 0);
        indentRef.dimMatches(indent);

        // bottom rabbet
        const bottomRabbet = shape.lineTo(0, 20);
        shape.addDimension(bottomRabbet.pointA, bottomRabbet.pointB, detail.bottomRabbetDepth);

        const bottomFace = shape.lineTo(-10, 0);

        bottomFace.dimMatches(topFace);
        bottomFace.linkDimension(jambFace);

        shape.addDimension(startPoint, bottomFace.getEndpoint(), jambDepth);
        // clamshell secondary side: omit the top/bottom faces so the primary side's
        // faces cap the merged mullion (avoids a doubled/gapped cap).
        if(hideFaces) { topFace.setPenUp(); bottomFace.setPenUp(); }
        if(hideFaces || hideFaceDims) shape.hideDimensionsForVars([jambFace, jambDepth]);
        this.faceAnchor.setLocalPoint(topFace.getStartpoint());
        shape.done();
    }
}